import React, { useState } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface Testimonial {
  quote: string;
  name: string;
  title: string;
}
const testimonials: Testimonial[] = [{
  quote: "Bright & Clean transformed our office. The team is professional, thorough, and always on time. We couldn't be happier.",
  name: 'Sarah M.',
  title: 'Office Manager'
}, {
  quote: 'We switched from our previous vendor and the difference was night and day. Our building has never looked better.',
  name: 'James R.',
  title: 'Property Manager'
}, {
  quote: 'Reliable, affordable, and they actually listen to feedback. Exactly what we needed.',
  name: 'Linda K.',
  title: 'Clinic Administrator'
}];
function TestimonialCard({
  testimonial
}: {
  testimonial: Testimonial;
}) {
  return <div className="bg-[#F5F7FA] rounded-xl p-8 h-full flex flex-col" data-id="element-191">
      {/* Quote Mark */}
      <span className="text-6xl text-[#0E7C86]/20 font-serif leading-none" data-id="element-192">
        "
      </span>

      {/* Quote Text */}
      <p className="text-gray-700 italic flex-1 mt-2 mb-6" data-id="element-193">
        {testimonial.quote}
      </p>

      {/* Author Info */}
      <div data-id="element-194">
        <p className="font-bold text-gray-900" data-id="element-195">{testimonial.name}</p>
        <p className="text-gray-500 text-sm" data-id="element-196">{testimonial.title}</p>

        {/* Stars */}
        <div className="flex gap-1 mt-3" data-id="element-197">
          {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-yellow-400" data-id="element-198" />)}
        </div>
      </div>
    </div>;
}
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <section id="testimonials" className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-199">
      <div className="max-w-7xl mx-auto" data-id="element-200">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-16" data-id="element-201">
          What Our Clients Say
        </h2>

        {/* Desktop Grid - Show All 3 */}
        <div className="hidden md:grid md:grid-cols-3 gap-8" data-id="element-202">
          {testimonials.map((testimonial, index) => <TestimonialCard key={index} testimonial={testimonial} data-id="element-203" />)}
        </div>

        {/* Mobile Carousel - Show 1 at a time */}
        <div className="md:hidden" data-id="element-204">
          <div className="relative" data-id="element-205">
            <TestimonialCard testimonial={testimonials[currentIndex]} data-id="element-206" />

            {/* Navigation Arrows */}
            <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors" aria-label="Previous testimonial" data-id="element-207">
              <ChevronLeftIcon className="w-5 h-5 text-gray-600" data-id="element-208" />
            </button>
            <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors" aria-label="Next testimonial" data-id="element-209">
              <ChevronRightIcon className="w-5 h-5 text-gray-600" data-id="element-210" />
            </button>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-6" data-id="element-211">
            {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-3 h-3 rounded-full transition-colors ${index === currentIndex ? 'bg-[#0E7C86]' : 'bg-gray-300'}`} aria-label={`Go to testimonial ${index + 1}`} data-id="element-212" />)}
          </div>
        </div>
      </div>
    </section>;
}